import { request } from '@/utils/request'

// 交卷(获取学分)/onlineCourse/earnCredits
export function earnCredits( data ) {
  return request({
    url: `/teachingCenter/onlineCourse/earnCredits`,
    method: 'post',
    data
  })
}
// 领取证书/onlineCourse/certificate/collect
export function collect( data ) {
  return request({
    url: `/teachingCenter/onlineCourse/certificate/collect`,
    method: 'post',
    data
  })
}
// 证书进度/onlineCourse/certificate/progress
export function progress( params ) {
  return request({
    url: `/teachingCenter/onlineCourse/certificate/progress`,
    method: 'get',
    params
  })
}

// 我的在线课程详情/onlineCourse/myStudyDetail/{onlineCourseId}
export function myStudyDetail( onlineCourseId ) {
  return request({
    url: `/teachingCenter/onlineCourse/myStudyDetail/${ onlineCourseId }`,
    method: 'get',
  })
}
// 
export function myStudy(data) {
  return request({
    url: '/teachingCenter/onlineCourse/myStudy',
    method: 'get',
    params: data
  })
}

// 判断用户身份
export function isStudents(){ 
  return request({
    url: '/teachingCenter/onlineCourse/isStudents',
    method:"get",
  })
}